import { createFileRoute } from "@tanstack/react-router";

import { AssessmentPage } from "../../pages/assessment/Assessment.page";

export const Route = createFileRoute("/_protected/assessment")({
  component: AssessmentPage,
});
